module.exports = __webpack_public_path__ + "img/chooseStore.f1913b8f.png";